import { Body, Spacer } from '@spritz-finance/ui'
import React from 'react'
import { Card } from '../../../components/Layout/Card'
import { Column } from '../../../components/Layout/Column'
import { useCurrentUser } from '../../../context/useCurrentUser'
import { formatPhoneNumber } from '../../../utils/format'
import { FormContainer } from './UserInfoStyled'

type UserInfoFormProps = {
    style?: React.CSSProperties
}

export const UserInfoForm: React.VFC<UserInfoFormProps> = ({ style }) => {
    const { me } = useCurrentUser()

    return (
        <Card>
            <FormContainer style={style}>
                <Body.SmBold size={18}>Your Details</Body.SmBold>
                <Spacer height={16} />
                <Column>
                    <Body.SmBold size={16}>First Name</Body.SmBold>
                    <Spacer height={4} />
                    <Body.Med size={14}>{me?.firstName}</Body.Med>
                    <Spacer height={16} />
                    <Body.SmBold>Last Name</Body.SmBold>
                    <Spacer height={4} />
                    <Body.Med size={14}>{me?.lastName}</Body.Med>
                    <Spacer height={16} />
                    <Body.SmBold>Email address</Body.SmBold>
                    <Spacer height={4} />
                    <Body.Med size={14}>{me?.email}</Body.Med>
                    <Spacer height={16} />
                    <Body.SmBold>Phone Number</Body.SmBold>
                    <Spacer height={4} />
                    <Body.Med size={14}>{me?.phone ? formatPhoneNumber(me?.phone) : ''}</Body.Med>
                </Column>
            </FormContainer>
        </Card>
    )
}
